import { Avatar, Button, Card, Flex, Typography } from 'antd'
import { useTheme } from 'antd-style'
import { ChevronRight } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import type { OrganizationLong } from 'src/api/main'
import { AvatarWithInitials } from 'src/components/AvatarWithInitials/AvatarWithInitials'

import { useStyles } from './styles'

const { Text, Title } = Typography

type Props = {
  organization: OrganizationLong
}

export const OrganizationCard = ({ organization }: Props) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const { styles } = useStyles()

  const orgUrl = `https://${organization?.domain_name}.${import.meta.env.VITE_APP_DOMAIN_URL}`

  return (
    <Card variant="outlined" className={styles.card}>
      <Flex align="center" gap={16}>
        {organization?.photo !== null ? (
          <Avatar src={organization?.photo?.file} size={64} />
        ) : (
          <AvatarWithInitials id={organization?.id} name={organization?.name} />
        )}

        <Flex orientation="vertical">
          <Title level={5} className={styles.organization}>
            {organization?.name}
          </Title>
          <Text className={styles.role}>{t('admin')}</Text>
        </Flex>

        <Button
          icon={<ChevronRight size={20} color={theme.colorTextTertiary} />}
          onClick={() => window.location.assign(orgUrl)}
          size="large"
          className={styles.button}
        />
      </Flex>
    </Card>
  )
}
